import $ from 'jquery'

class CollapseOrExpandAll {
	constructor(el, options) {
		this._handleWindowCollapseShow = this._handleWindowCollapseShow.bind(this)
		this._handleWindowCollapseHide = this._handleWindowCollapseHide.bind(this)
		this._handleWindowCollapseShown = this._handleWindowCollapseShown.bind(this)
		this._handleWindowCollapseHidden = this._handleWindowCollapseHidden.bind(this)
		this._handleClick = this._handleClick.bind(this)

		this.el = el;
		this._collapses = el.getAttribute('aria-controls').replace(/\s\s+/g, ' ').trim().split(' ')
		this._expandedCollapses = this._collapses.filter(id => $(`#${id}`).hasClass('show'))
		this._allExpanded = this._expandedCollapses.length === this._collapses.length

		$(el).on('click', this._handleClick)
		$(window).on('show.bs.collapse', this._handleWindowCollapseShow)
		$(window).on('hide.bs.collapse', this._handleWindowCollapseHide)
		$(window).on('hidden.bs.collapse', this._handleWindowCollapseHidden)
		$(window).on('shown.bs.collapse', this._handleWindowCollapseShown)
	}

	_updateButtonState () {
		if (this._allExpanded) {
			$(this.el).addClass('all-expanded')
		} else {
			$(this.el).removeClass('all-expanded')
		}
	}

	_handleWindowCollapseShow(event) {
		const { id } = event.target

		if (this._collapses.indexOf(event.target.id) !== -1) {
			this._expandedCollapses.push(id)
			this._allExpanded = this._expandedCollapses.length === this._collapses.length
			this._updateButtonState()
		}
	}

	_handleWindowCollapseHide(event) {
		const {id} = event.target

		if (this._collapses.indexOf(id) !== -1) {
			if (this._triggeredByButton && !this._allExpandedWhenButtonWasClicked) {
				// Prevent hide if collapse was triggered by button and not all collapses were open
				event.preventDefault()
			} else {
				const index = this._expandedCollapses.indexOf(id)
				this._expandedCollapses.splice(index, 1)
			}
			this._allExpanded = this._expandedCollapses.length === this._collapses.length
			this._updateButtonState()
		}
	}

	_handleWindowCollapseHidden(event) {
		if (this._collapses.indexOf(event.target.id) !== -1) {
			this._triggeredByButton = false
		}
	}

	_handleWindowCollapseShown(event) {
		if (this._collapses.indexOf(event.target.id) !== -1) {
			this._triggeredByButton = false
		}
	}

	_handleClick(event) {
		this._allExpandedWhenButtonWasClicked = this._allExpanded
		this._triggeredByButton = true
	}
}

// Plugin factory
$.fn.collapseOrExpandAll = function (options) {
	return this.each((index, el) => {
		const instance = new CollapseOrExpandAll(el, options)
		$(el).data('collapseOrExpandAll', instance)
	})
}

export default CollapseOrExpandAll
